export default "__VITE_ASSET__b10920b2__"